$(document).ready(function () {

  $("deferred-media").each(function () {
    const media = $(this);
    const template = media.find("template");

    if (template.length) {
      media[0].loadContent();
    }
  });



  
});
